export var valuesPPNAndEmailFromSameUser = ["None", "PPX", "PPN"];
/*

*/ 
//# sourceMappingURL=PPNAndEmailFromSameUser.js.map